import React from 'react';
import { useHistory } from 'react-router-dom';

const AccessDenied = () => {

  let history = useHistory();
  return (
    <div 
      className="d-flex
                  flex-column
                  justify-content-center 
                  align-items-center 
                  forbidden text-white">
      <h1 className="text-center display-1 fw-bold">401</h1>
      <p>Acceso denegado</p>
      <button className="btn btn-warning rounded-pill" onClick = {() => history.goBack ()}><i className="material-icons">history</i> Volver a la página anterior </button> 
    </div>
  )
}

export default AccessDenied
